<template>
  <div class="InsightsFilterPanel">
  </div>
</template>

<script>
import loadInsights from './loadInsights'

export default {
  model: {
    prop: 'rulesets',
    event: 'update'
  },
  props: {
    rulesets: {
      type: Array,
      required: true
    }
  },
  created() {
    loadInsights().then((api) => {
      // console.log('===============')
      // console.log('loaded insights')
      // console.log(api)
      // Most of the Insights app relies heavily on an internal Vuex store
      // and specific data structures. This prevents us from simply exposing
      // the filter panel component as normal.
      // Instead Insights must create its own Vue instance bound to its
      // internal store and then wrap the filter panel.
      // This means we will have to inject the instance into the DOM manually.
      api.createFilterPanel({
        data: {
          // Pass in any initial rulesets
          rulesets: this.rulesets
        },
        on: {
          update: (event) => {
            // Array of ruleset definitions for use in UI
            this.$emit('update', event.error ? null : event.ui)
            // Array of ruleset definitions for querying with analytics server
            this.$emit('result', event.error ? null : event.server)
          }
        }
      }).then((vm) => {
        // Mount the VM and insert it into the DOM
        vm.$mount()
        this.$el.appendChild(vm.$el)
        this.$emit('loaded')
        this.filterPanelVm = vm
      })
    })
  },
  methods: {
    updateRulesets(rulesets) {
      this.filterPanelVm.rulesets = rulesets
    }
  }
}
</script>
